var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceLeads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18575_107176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4405 18C22.1898 18 22.7858 17.5285 23.3209 16.8691C24.4164 15.5194 22.6178 14.4408 21.9318 13.9126C21.2345 13.3756 20.4559 13.0714 19.6665 13M18.6665 11C20.0472 11 21.1665 9.88071 21.1665 8.5C21.1665 7.11929 20.0472 6 18.6665 6",
    stroke: "#3E93FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89247 18C3.14316 18 2.54718 17.5285 2.01205 16.8691C0.916595 15.5194 2.71518 14.4408 3.40115 13.9126C4.09848 13.3756 4.87709 13.0714 5.66651 13M6.16651 11C4.7858 11 3.66651 9.88071 3.66651 8.5C3.66651 7.11929 4.7858 6 6.16651 6",
    stroke: "#3E93FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75031 15.1112C7.72853 15.743 5.04949 17.0331 6.68121 18.6474C7.47829 19.436 8.36603 20 9.48213 20H15.8509C16.967 20 17.8547 19.436 18.6518 18.6474C20.2835 17.0331 17.6045 15.743 16.5827 15.1112C14.1866 13.6296 11.1463 13.6296 8.75031 15.1112Z",
    stroke: "#3E93FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 7.5C16.1665 9.433 14.5995 11 12.6665 11C10.7335 11 9.1665 9.433 9.1665 7.5C9.1665 5.567 10.7335 4 12.6665 4C14.5995 4 16.1665 5.567 16.1665 7.5Z",
    stroke: "#3E93FF",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18575_107176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceLeads);
export default __webpack_public_path__ + "static/media/performance-leads.f44d9e71de1a35f10c406f4ce66c5969.svg";
export { ForwardRef as ReactComponent };